import axios from "axios";
import RoutingService from './routing';

const pagesInfo = window.config.pagesInfo ? window.config.pagesInfo : [];

export default {
  getPage: async type => {
    const response = await axios.get('/api/pages/' + type);
    return response.data;
  },
  getPageInfo: $router => {
    const pageName = RoutingService.getPageName($router);
    console.log(pageName);
    return pagesInfo.find(p => p.name === pageName) || {
      partners: []
    };
  }
};
